module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//rename-bg.png?v=7c304261";